import React from 'react';
import { Form, Row } from 'antd';
import { Catcher } from '../../';
import { EditRateFormMain, EditSalesRateList } from './';
import { IEditForm } from '../../../interfaces';
import Styles from '../../styles/m_itemCardStyles.less';

export const EditRateForms: React.FC<IEditForm> = ({ setEditMode, isNew = false, loadingTypes }: IEditForm) => {
    return (
        <Catcher>
            <div className={Styles.main}>
                <Form.Provider>
                    <EditRateFormMain setEditMode={setEditMode} isNew={isNew} loadingTypes={loadingTypes} />

                    <Row>
                        <EditSalesRateList />
                    </Row>
                </Form.Provider>
            </div>
        </Catcher>
    );
};
